<ion-app>
	<ion-menu contentId="main-content" type="overlay" class="menu">
		<ion-header class="ion-no-border padding-top-30 padding-bottom-30 padding-left-35 padding-right-35">
			<ion-menu-toggle auto-hide="true">
				<img class="img-logo-menu clickable" src="assets/imgs/logo.svg" alt="">
			</ion-menu-toggle>
		</ion-header>
		<ion-content class="background-menu">
			<ion-grid>
				<ng-container *ngFor="let page of pages; let i = index">
					<ng-container *ngIf="page.pages">
						<ion-row class="clickable" [ngClass]="{'margin-top-50': i === 0, 'margin-bottom-20': page.expanded, 'margin-bottom-30': !page.expanded}" (click)="expandCollapsePage(page)">
							<ion-col class="ion-no-padding padding-left-20 padding-right-15 ion-align-self-center">
								<img class="img-icon-menu margin-right-20 vertical-align-middle" [src]="page.selected ? page.iconActive : page.icon" alt="">
								<ion-text class="vertical-align-middle" [ngClass]="{'text-style-5': page.selected, 'text-style-28': !page.selected}">{{ page.title }}</ion-text>
							</ion-col>
							<ion-col size="auto" class="ion-no-padding padding-right-15 ion-align-self-center">
								<img class="img-expand-menu margin-right-20" [src]="page.expanded ? '/assets/imgs/moins.svg' : '/assets/imgs/plus.svg'" alt="">
							</ion-col>
						</ion-row>
						<ng-container *ngIf="page.expanded">
							<ng-container *ngFor="let subpage of page.pages; let j = index">
								<ion-menu-toggle auto-hide="true">
									<ion-row [ngClass]="{'margin-bottom-30': j === page.pages.length - 1, 'margin-bottom-15': j < page.pages.length - 1}">
										<ion-col class="clickable ion-no-padding padding-left-50 padding-right-15 ion-align-self-center" (click)="navigationService.goToInternal(subpage.url, subpage.params)">
											<ion-text [ngClass]="{'text-style-29': subpage.selected, 'text-style-28': !subpage.selected}">{{ subpage.title }}</ion-text>
										</ion-col>
									</ion-row>
								</ion-menu-toggle>
							</ng-container>
						</ng-container>
					</ng-container>
					<ng-container *ngIf="!page.pages">
						<ion-menu-toggle auto-hide="true">
							<ion-row class="margin-bottom-30" [ngClass]="{'margin-top-50': i === 0}">
								<ion-col class="clickable ion-no-padding padding-left-20 padding-right-15 ion-align-self-center" (click)="page.internal ? navigationService.goToInternal(page.url, page.params) : navigationService.goToExternal(page.url)">
									<img class="img-icon-menu margin-right-20" [src]="page.selected ? page.iconActive : page.icon" alt="">
									<ion-text [ngClass]="{'text-style-29': page.selected, 'text-style-28': !page.selected}">{{ page.title }}</ion-text>
								</ion-col>
							</ion-row>
						</ion-menu-toggle>
					</ng-container>
				</ng-container>
			</ion-grid>
		</ion-content>
		<ion-footer class="ion-no-border background-peacock-blue">
			<ion-grid class="ion-no-padding padding-top-15 padding-bottom-15">
				<ion-row class="margin-bottom-15">
					<ion-col class="ion-no-padding ion-text-center padding-left-10 padding-right-10">
						<ion-text class="text-style-30 ion-text-wrap">{{ userConnected?.full_name }}</ion-text>
					</ion-col>
				</ion-row>
				<ion-row class="clickable margin-bottom-15" (click)="deconnexion()">
					<ion-col class="ion-no-padding ion-text-center">
						<ion-menu-toggle auto-hide="true">
							<button class="background-transparent">
								<img class="img-logout-menu margin-right-15 vertical-align-middle" src="assets/imgs/deconnexion.svg" alt="">
								<ion-text class="text-style-30 vertical-align-middle">Déconnexion</ion-text>
							</button>
						</ion-menu-toggle>
					</ion-col>
				</ion-row>
				<ion-row>
					<ion-col class="ion-no-padding ion-text-right padding-left-10 padding-right-10">
						<ion-text class="text-style-30">v{{ appVersion }}</ion-text>
					</ion-col>
				</ion-row>
			</ion-grid>
		</ion-footer>
	</ion-menu>
	<ion-router-outlet id="main-content"></ion-router-outlet>
</ion-app>
